import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { appendFormDataWithObjectValues, customFetch } from 'utils/http';

type Params = {
  idPartner: number;
  idClient: number;
  comission: number;
};

export const setPartnerComissionForClient = async (
  params: Params
): Promise<void> => {
  const body = new FormData();
  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(
    getM8AdminURL('setPartnerComissionForClient'),
    {
      method: 'POST',
      body,
    }
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
